export default {
  lang: {
    expressOrder: 'Courier Num',
    transferOrder: 'AWB',
    storeSet: 'Warehouse',
    equipment: 'External equipment',//外接设备
    scaleConnect: 'Scale connection',//外接设备
    printerConnect: 'Printer',
    previewTestPrinter: 'Preview printing',
    selectStoreTip: 'Please select the warehouse you want to configure',
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    selectDeviceTip: 'Please select an external device',
    noEquip: 'Nil equipment detected',
    scaleInstrument: 'Scale instrument',
    bulkWeightInstrument: 'Bulk weight instrument',
    DWSInstrument: 'DWS instrument (HTTP)',
    plugID: 'Plug in ID',
    selectPlugIDTip: 'Please enter the Chrome browser plug-in ID',
    getID: 'Submit',
    downloadScale: 'Download scale plug-in',
    port: 'Port',
    selectPortTip: 'Please select or enter a port',
    selectTip: 'Please select first!',
    unKnown: 'unknown',
    defaultPrinter: 'Default Printer',
    printer: 'Printer',
    notYet: 'N/A',
    helpDocument: 'Help documentation',
    loginOut: 'Logout',
    VXScan: 'Scan wechat',
    mobileTip: 'The mobile terminal is more convenient to operate',
    searchLengthTip: 'Transit order No. only. When the length is 30 digits, the first 8 digits are intercepted, and other lengths or order numbers are not affected',
    searchContentTip: 'Search content cannot be empty!',
    scanWarning: 'Do not scan the confirmation code!',
    exitTip: 'Are you sure to exit?',
    location: 'Location',
    warehousing: 'Inbound',
    warehousingFunction: 'Inbound Functions',
    oldVersionEntry: 'Old Version Entry',
    getStarted: 'Get Start',
    youCanChoose: 'You can choose this mode.',
    manualScan: 'Manual scanning',
    findUserNotify: 'Find the user. Used to locate users when exceptions occur.',
    submitCodeNotifyOne: 'Confirmation code download.',
    submitCodeNotifyTwo: 'Scan the "confirmation code" instead of the enter key.',
    stopScanSubmitCode: 'Do not scan the "Confirmation Code"',
    notFoundNoNotify: 'No order associated with the tracking number was found',
    singlePackageWarehouse: 'Applicable to Single parcel inbound operation,',
    batchScan: 'Batch Operation',
    capacityScan: 'Capacity Operation',
    largePackageWarehouse: 'Recommend for Courier/FBA/Dedicate shipping mode,',
    capacityPackageWarehouse: 'Pallet cargo storage',
    autoScan: 'Sorting Automation',
    autoSetting: 'Sorter access, subcontracting strategy setting',
    batchMode: 'Batch Mode',
    scanModel: 'Scan Mode',
    warehouseNo: 'Courier No.',
    warehouseNoSearch: 'Courier No.',
    transshipmentNo: 'AWB',
    entryCustomerNo: 'Client Entry No.',
    transshipmentNoSearch: 'AWB No.',
    scanPosition: 'Scan Position ',
    noPlaceholder: 'Press enter to confirm, otherwise it is abnormal warehousing',
    normalOrder: 'Normal',
    normalInstore: 'Normal warehousing',
    realTimeLens: 'Real times lens',
    photoSave: 'photo saving',
    warehouseInfo: 'Inbound Info',
    actualWeight: 'weight',
    packageCodeMode: 'Package code mode',
    length: 'L',
    width: 'W',
    height: 'H',
    predictionInfo: 'Forecast information',
    prePiece: 'Quantity',
    number: 'Pieces',
    expend: 'open',
    fold: 'close',
    abnormalOrder: 'Abnormal',
    preWeight: 'weight',
    orderTime: 'Order Date',
    sysNo: 'System No',
    multiPackageInfo: 'Multi package information',
    index: 'NO',
    packageCode: 'Package No.',
    weighing: 'Weighing',
    photo: 'Photo',
    remarks: 'Remarks',
    fillTip: 'Fill in the message',
    printLabel: 'Print Label',
    sheet: 'sheet ',
    batchInStore: 'Batch warehousing ',
    packageQuantity: 'Package',
    totalWeight: 'Weight ',
    addOneGroupPackage: 'Add new',
    batchUpload: 'Upload ',
    see: 'Check',
    confirmCodeDownload: 'Confirmation code download',
    confirmCodeDownloadTip: 'Look here: after downloading and printing, paste it on the ground and scan it with a code scanning gun to represent "confirmation".',
    oneDimCodeDown: 'Bar code download',
    qrCodeDown: 'QR code download ',
    download: 'Download',
    back: 'Back',
    userNameLockTip1: '1.When a user is locked, all receipts will be recorded in the user library',
    userNameLockTip2: '2.After successful warehousing, unlocked users will be removed. User search" can be reopened',
    pieceDiff: 'Wrong Quantity',
    pieceSame: 'Correct quantity',
    createAbnormalTip1: 'Create exception？',
    createAbnormalTip2: 'No information in the system,',
    createAbnormalTipCapacity: 'No information in the system, and the customer\'s entry number:',
    createAbnormalTip3: 'Scan "confirmation code" to create it directly',
    createAbnormalTip4: 'If the confirmation code is invalid, click “Scan Position”',
    findUser: 'Find users',
    selectCustomer: 'Select customer please！',
    findUserPlaceholder: 'Please enter the customer code you want to find below',
    lockUser: 'Lock user',
    lockUserTip: "After locking, all abnormal parts will be entered into the user's warehouse.",
    piece:'piece',
    versionNotSupport:'Your version does not support this feature',
    serviceConsult:'For details, please consult customer service 400-805-9105',

    goodsEntry:'GoodsInspection',
    newGoodsEntry:'Enter inventory',
    itemNumber:'Item number',
    save:'Save',
    averageWeight:'Average weight',
    averageWeightNotify:'When this function is enabled, the system does not need to enter the weight, the total weight will be evenly distributed to each item.',
    entryItemDetails:'Entry of item details',
    querySuccess:'Successful',
    delete:'Delete',
    entryGoodsComplete:'The package has been entered with commodity information',
    completeEntryGoods:'Complete the entry',
    addGoods:'Add the goods',
    submitPack:'Ok',
    packagingComplete:'Packaging is complete!',
    enterLength:'Please enter length',
    enterWidth:'Please enter width',
    enterHeight:'Please enter height',
    enterWeight:'Please enter weight',

    printCenter:'Print Center',
    printBill:'Printing',
    printTip:'The printer program needs to be installed, otherwise it will be exported in PDF format. Customer service Tel.: 400-805-9105',
    direct:'Direct',
    gather:'Concentrated',
    scanNo:'Scan No.',
    scanNoPlaceholder:'Press enter to confirm',
    noPlaceholderOther: 'Press enter to confirm',
    orderNoType:'Scan Numbers',
    wayBillType:'Print Type',
    orderBill:'Order',
    forecastBill: 'Forecast',
    mergeBill:'Merge',
    customDefaultAddress: 'Customer default address',
    printQuantity:'Quantity',

    currentDataStatistics:'Current data statistics',
    waitingDelivery:'Waiting for delivery',
    outboundDelivery:'Outbound delivery',
    outSet:'Settings',
    directDelivery:'Package',
    capacityDelivery:'Bag',
    printOrderLabel:'Print package label',
    printOrderAndMailBagLabel: 'Print package label and merge label ',
    mergeAndEXWarehouseMode:'Merge and Ex mode',
    refresh:'Refresh',
    cargoNo:'Order No.',
    cargoNoSearch:'Order No.',
    packageNo: 'Pack No.',
    unPackageNo: 'DPack No.',
    outPassTime:'Delivery instruction pass time',
    transportChannel:'Transportation channel',
    deliveryArea:'Delivery area',
    inside: 'Inside ',
    insideList: 'Inside list',
    subcontract: 'Subcontract',
    splitOrderNum: 'Num.sub',
    senderAddressCount: 'No of sub',
    orderStatus: 'State ',
    operation: 'Operation',
    scanOperation: '',
    viewDetail: 'Details',
    goPack: '',
    pending: 'Pending',
    processed: 'Processed',
    completed: 'Completed',
    subAndPack: 'Subcontract and pack',
    Delay: 'Waiting for packing',
    needPackItem: 'Need to pack',
    cargoName: 'Item',
    cargoOtherName: 'Alias',
    estimateWeight: 'Weight',
    cargoType: 'type',
    generalSundries: 'General / sundries',
    BatteryMotor: 'Battery, Motor, Traveling crane, Magnetic goods',
    liquidPowder: 'Liquid powder',
    cosmetics: 'Cosmetics',
    food: 'Food',
    needPackCount: 'Number',
    packageInfo: 'Package Information',
    noPhoto: 'No Photos',
    takePhoto: 'Take Pic',
    subcontractingInstruction: 'Subcontracting Instruction',

    notify:'Prompt',
    serverErrorNotify:'Error: Network Error',
    lastUpdateTime:'Last Modified time',
    operationSuccess:'operate successfully！',

    printBag:'Print merge label',
    previewPrintBag: 'Preview merge label',
    printPack:'Print pack label',
    printTemporary:'Print temporary label',
    printPackModelNotify: 'In this mode, the system will automatically detect and pay to complete the package, but the overall speed is slower',
    printTemporaryNotify: 'Temporary label can locate new packing label in Printing-Print Center',
    viewBagHistory:'View bag pooling history',
    selectMergeSheetStyle:'Select merge label style',
    enterLimitWeight:'Max weight',
    residualWeightForMerge:'Residual',
    completeMergeAndOut:'Merge and out',
    departure:'Departure',
    merge:'Merge',
    mergeHistory:'Merge History',
    mawbNo:'MAWB No.',
    portDeparture:'Port of Departure',
    portDestination:'Port of Destination',
    flightInfo:'Flight no.',
    outTime:'Out time',
    scan:'Scan',

    toBeStored:'Not yet inbound',
    preOrder:'Pre-order',
    stored:'Inbound already',
    inbound:'Inbound',
    inStorage:'In storage',
    outBound: 'OutBound',
    all: 'All',
    list: 'list',
    inStorageTime:'Inbound time',
    normal:'Normal',
    abnormal:'Abnormal',
    irregular:'Irregular',
    today: 'Today',
    numberOfOrders:'',
    search:'Search',
    reset:'Reset',
    orderDate:'Order date',
    warehousingDate:'Warehousing date',
    equipmentStatus:'Equip',
    weight:'Weight',

    deliveryCountry:'DSTN Country/Region',
    forecastStatus:'Status',
    updateInfo:'Modify',
    forecastList:'Cargo forecast',
    warehouseOverview: 'Overview',
    expandAllWarehouse: 'Expand all',
    packUpAllWarehouse: 'Pack up all',
    warehousesName: 'Name',
    currentWarehouse: 'Currently Selected',
    notFoundOrder:'The specified order was not found!',
    orderNotInStorage:'The order has not been put in storage, please put it in first!',
    orderSubmitStopModified:'The order has been confirmed the storage information, and the storage information cannot be modified!',
    go:'Go',

    multipleCargoModel:'There are multiple packages under this order and cannot be put into storage in this mode, please switch to batch storage mode or turn on package code mode',
    multipleCargoInStorageModel:'The piece is put into the warehouse in batch warehousing mode, it cannot be put in this mode, please switch to batch warehousing mode',
    singleCargoInStorageModel:'The item is stored in manual scan code mode, it cannot be stored in this mode, please switch to manual scan code mode',
    codeHadScan:'The package code has been scanned',
    cargoCodeNotNull:'Multi-package package code cannot be empty',
    notNullOrZero:'Cannot be empty and cannot be less than 0',
    abnormalOrderInStorage:'Abnormal parts have been put into storage',
    orderInStorage:'Successfully put into the warehouse',
    orderTemInStorage:'Has been temporarily stored in the warehouse',
    orderNotHadLabel:'There is no label for this order',
    uploadFailed:'Upload failed, please refresh and try again',

    continue:'Continue',
    submit:'Submit',
    willCloseOperation:'It has been detected that you are currently operating, continuing will close the operation',

    pendingOrder:'Pending',
    operationOrder:'Operation',

    test:'Test',
    insideTest:'In\nSide\nTest',
    parcelLocation:'Location',
    orders:'Orders',
    batchOrders:'Batch Orders',
    start:'Start',
    status:'Status',
    demandTime:'Demand Time',

    history:'History',
    cargoAndExpressNo:'Cargo/Express No',

    toBeTest:'Not in Test',
    inTest:'In Test',
    completeTest:'Test Completed',
    testServer:'Test service',

    pleaseFinishFirst:'Please finish picking up first',
    grabbedOrder:'Successfully grabbed the order!',
    grabbedOrderNotify:"After receiving the order, the order cannot be cancelled!",
    selectTestOrder:"Please select the test order!",
    testOrderCount:"Total number of test orders",
    inputCodeNotify:"Please enter the code!",
    countPackages:"Count Packages",
    serviceRemarks:"Service Remarks",
    testRequirements:"Test requirements",
    purchasingTest:"Purchasing test",

    reshelf:"On/Off Shelf",
    packagesOnShelf:"Packages on the shelf",
    wareHouse:"Warehouse",
    my:"My",
    parcelShelvesRecord:"Parcel On/Off Shelves Record",
    code:'Code',
    storageLocation:'Location',
    operatingTime:'Operating time',
    operator:'Operator',
    onShelfSuccess:'Success',
    onShelfFailed:'Failed',
    onShelfWaiting:'Waiting',
    onShelfScanNotify:'Please enter or scan the shelf number!',

    pack:'Pack',
    toBePack:'To be pack',
    packaged:'Packaged',
    packagedSuccess:'Packaged',
    waitingPacked:'Waiting packed',
    waitingPicked:'Waiting picked',
    packing:'Packing',
    packageCreateTime:'Create time',

    destCountry:'Dest country',
    serviceChannel:'Service channel',
    operableNumber:'Operable number',
    task:'Task',
    scanSuccessNoNotify:'Please scan the correct code!',
    selectPackageNoNotify:'Please select the package！',
    packageCount:'Total number of packages',
    cargoCount:'Count of cargo',
    pickedCount:'Count of picked',
    valueAddedServices:'Value-added services',
    message:'Message',
    upload:'Upload',
    packagePhotos:'Package\nphotos',
    cursorNotify:'To use the instrument, please click the cursor here',
    deviceInputError:'The incoming information from the device is incorrect',
    pickingSuccess:'Successfully picked!',
    quantityNotNullOrZero: 'Quantity cannot be empty and greater than 0!',
    lengthNotNullOrZero:'Length cannot be empty and greater than 0!',
    widthNotNullOrZero: 'Width cannot be empty and greater than 0!',
    heightNotNullOrZero: 'Height cannot be empty and greater than 0!',
    weightNotNullOrZero: 'Weight cannot be empty and greater than 0!',
    noWeightContinue: 'It is detected that the weight has not been entered. Do you want to continue packing?',
    packSuccess: 'Successfully packaged!!',
    stopPrintContent: 'No printable!',
    completedPackList: 'Completed packed list',
    completedUnpackList: 'Completed Dpacked list',
    startDate: 'Start Date',
    endDate: 'End date',
    packWeight: 'weight',
    packLWH: 'L/W/H',
    packVolume: 'volume',
    packCompletionDate: 'Completion time',
    selectNeedPrint: 'Please select the order to be printed!',

    completeBagging: 'Complete merge',
    spellBagSetting: 'Merge Setting',
    waitMergePackage: 'To be merge of package',
    mergePackage: 'Merge package',
    pendingCapacityOrder: 'Pending',
    designatedCapacityOrder: 'Designated',
    grossWeight: 'Gross weight',
    spelled: 'Merge',
    bag: 'Bags',
    directOrder: 'Direct order',
    consolidationOrder: 'Consolidation order',
    limitWeightNotify: 'The weight limit cannot be less than 0 and cannot be less than the weight of the assembled bag',
    setLimitWeight: 'Please set a single bag weight limit first',
    exceedWeight: 'The actual weight has exceeded the baggable weight',
    scanned: 'Scanned',
    scanCorrectCargoOrder: 'Please scan the correct QR code of Cargo!！',
    cargoNotReviewedStopSpell: 'The package has not yet been reviewed and cannot be merge！',
    cargoBound: 'This package has been booked, is it mandatory to put this bag together?',
    cargoRemoved: 'The package has been removed！',
    destCountryNotAssembledStopMerge: 'The destination country of the parcel is inconsistent with the destination country of the parcel already assembled, and the bag cannot be merge！',
    routeNotAssembledStopMerge: 'The parcel moving route is inconsistent with the route of the existing parcels, and the bag cannot be merge!',
    scanNeedMergeOrder: 'Please scan the order that needs to be merge！',
    selectLabelStyle: 'You have chosen to print the label, please select the label style！',
    addNeedMergePackage: 'Please add the packages that need to be merge first！',
    successMerge: 'Successfully merge！',
    pouchNo: 'Pouch No',
    shipmentList: 'Shipment\nList',
    bindTheMAWB: 'MAWB has been bound',
    notBoundTheMAWB: 'Do not bind the MAWB',
    pouchOutStore: 'Pouch out of the warehouse',
    transferOrderOutStore: 'TransitOrder out of the warehouse',
    selectMAWB: 'Please select the MAWB',
    orderSent: 'The order has been sent',

    packLabel: 'Pack',
    inputOrScanCode: 'Please enter or scan the code',

    notFoundCodeOrder: 'The code information was not found!',
    notQrCodeSearch: 'Currently does not support package QR code search!',
    createTime: 'Create time',
    anomalous: 'Anomalous',
    returnOpera: 'Return',
    batchNum: 'Processing No.',
    processingMethod: 'Processing method',
    returnGoods: 'Return',
    destroy: 'Destroy',
    lost: 'Wait',
    selectOrder: 'Please select an order first!',
    countOrder: 'Total number of orders',

    claim: 'Claim',
    claimPic: 'Claim Pic',
    claimTitle: 'Claim\nList',


    locationManage: 'Location management',
    available: 'En',
    deactivate: 'Dis',
    numLocation: 'Number',
    addAreaNo: 'Add area',
    addLocation: 'Add location',
    allStatus: 'All status',
    allLocationTypes: 'All types',
    locationTypes: 'Location type',
    areaNum: 'Area No.',
    shelfNum: 'Shelf No.',
    locationNum: 'Location No.',
    batchOperationType: 'Batch Operation Type',
    batchOperation: 'Batch Operation',

    pickArea: 'Picking area',
    scrapArea: 'Scrap area',
    stockArea: 'Stocking area',
    operationArea: 'Operating area',
    pcsNumber: 'PCS contained',
    updateTime: 'Update time',
    modifier: 'Modifier',
    viewCargo: 'View cargo',
    stopListing: 'Suspend',
    reinstatement: 'Enable',
    locationListTitle: 'Location\nList',
    batchPrinting: 'Batch printing',
    stoppedInBatches: 'Stopped in batches',
    resumingInBatches: 'Resuming in batches',
    deleteLocationsInBulk: 'Delete locations in bulk',
    selectOperationOrders: 'Please select the order that needs to be processed first!',
    updateSuccess: 'Successfully modified!',
    deleteNotify: 'After deletion, it cannot be restored. Do you want to continue?',
    deleteSuccess: 'Successfully deleted!',
    selectPlease: 'Please choose',
    limitTwoDigits: 'Only two digits',
    codeSuggest: 'Suggested coding method: such as A01, A02',
    confirmCreation: 'Create',
    inputAreaNoPlease: 'Please enter the area number!',
    addSuccess: 'Added successfully!',
    noAreaNumNotify: 'If there is no optional partition number, please go to add partition number to create',
    upToSixDigits: 'Up to 6 digits',
    startLine: 'Start row',
    terminationLine: 'End row',
    upToEightLines: 'Up to 8 lines',
    startColumn: 'Start col',
    stopColumn: 'End col',
    upTo100Columns: 'Up to 100 columns',
    createLocationNum: 'Number of generated libraries this time',
    locationPreview: 'Preview',
    numLimit: 'The shelf number cannot be less than 0 or contain decimals!',
    startColumnLimit: 'The starting column cannot be greater than 99 or less than 0, equal to 0, and include decimals!',
    endColumnLimit: 'The termination column cannot be greater than 100 or less than 0, equal to 0, and include decimals!',
    startOrEndColumnLimit: 'The end column cannot be smaller than the start column!',
    startLineLimit: 'The starting line cannot be greater than 7 or less than 0, equal to 0, and include decimals!',
    endLineLimit: 'The terminating line cannot be greater than 8 or less than 0, equal to 0, and include decimals!',
    startOrEndLineLimit: 'The ending line cannot be smaller than the starting line',
    shelfNumNotNull: 'The shelf number cannot be empty!',
    startColumnNotNull: 'The start column cannot be empty!',
    startLineNotNull: 'The start line cannot be empty!',
    stopColumnNotNull: 'Stop column cannot be empty!',
    terminationLineNotNull: 'Termination line cannot be empty!',

    wareHouseOrderDetail: 'Order query details in the warehouse',
    basicInfo: 'Base info',
    deliveryMethod: 'Delivery method',
    directType: 'Direct',
    transferType: 'Transit',
    gatherType: 'Gather',
    orderMemberCode: 'Customer code',
    sendInfo: 'Send information',
    product: 'Product',
    spellNo: 'Spell No.',
    consigneeName: 'Consignee',
    consigneeCompany: 'Consignee Company',
    consigneeCountry: 'Consignee Country',
    consigneeProvince: 'Consignee State/Province',
    consigneeCity: 'Consignee City',
    address: 'Address',
    inBoundInfo: 'Inbound info',
    allGrossWeight: 'Gross weight',
    orderOfPackage: 'Order number of packages',
    warehousingPic: 'Warehousing photos',
    LHW: 'L.W.H',

    abnormalOrderOpera: 'Abnormal order process',
    scanPick: 'Scan pick',

    returnAddress: 'Return address',
    shippingCurrency: 'Shipping currency',
    returnShippingFee: 'Return shipping fee',

    finish: 'Finish',
    pickNotComplete: 'Picking work is not completed!',
    returnNoNotNull: 'The return courier number cannot be empty!',
    returnFeeNotNull: 'Return shipping fee cannot be empty!',
    submitSuccess: 'Successfully submitted!',
    completeOrder: 'Handling order completed',
    completeTime: 'Completion date',

    check:'Check',
    warehousingTest:'Warehousing test',
    ProcessingFeedback:'Processing feedback',
    leaveMessageToCustomer:'Leave message to service',
    photoUpload:'Photo upload',

    stopUpdateContinue:'cannot be modified afterwards, do you want to continue?',
    finishTestOrder:'Test order completed',
    finishCheckOrder:'Check order completed',
    addedItemInfo:'Added item info',
    appendix:'Annex',
    notUploaded:'Not uploaded',
    containsDetails:'Contains details',
    volume:'Volume',
    viewContainedGoods:'View contained goods',
    locationInfo:'Location info',
    packageOrderInfo:'Order info',
    numOrder:'Number of order',
    box:'Box',
    boxNum:'Number',
    orderer:'Orderer',
    billingWeight:'Billing weight',
    exportPackageExcel:'Export package to Excel',
    ownedMawbNo:'MAWB No.',
    mailbagWeight:'Weight',
    containedOrders:'Contained orders',
    selectMailBag:'Please select the mail bag to be exported!',
    mailBagParcel:'Mail bag parcel',
    modifyWarehousingInfo:'Modify warehousing info',
    confirmChanges:'Modify ',

    failedToRemove:'Failed to remove',
    setWeightNotify:'Please go to the homepage to set up the scale, otherwise the scale will not be connected!',
    failConnectWeightSuggestOne:'Failed to connect to the scale, it is recommended to plug and unplug the data cable or restart the device',
    failConnectWeightSuggestTwo:'Failed to connect to the scale, the device is not found, please go to the home page -> Set up the scale connection to check the configuration problem',
    nothingToPrintYet:'Nothing to print yet',
    printFailNotify:'Printing failed, printing software may not be installed, etc., please try again',
    retry:'Retry',
    failGetLabel:'Failed to get label',


    login:'Login',
    loginTitle:'WMS SYSTEM',
    account:'Account',
    password:'Password',
    wms:'WMS',

    preWarehouseDeliveryTime:'Pre-warehouse delivery time',
    packageNotBagContinue:'The package is not in the current mail bag demand. Will you continue to add it?',
    notInStoreCannotSpell:'The current merge demand package has not entered the current warehouse, and it is not possible to add packages that are not under this merge!',
    package:'Package',
    parcels:'Parcels',

    unPack:"Unpacking",
    unPackBag:"Unpacking",

    unOpened:"Unopened",
    unPacked:"Unpacked",

    packageList:'Package',
    bagList:'Bag',


    cargoCodeModelNotify:"Multiple packages need to be entered, please enable this function. Or you can click \"Batch Mode\" in the upper right corner.",
    continueWarehousing:"Continue Warehousing",

    deviceStatusNormal:'Status',
    chooseOrder:'Select',
    chooseNeedInboundOrder:'Manually select the orders that need to be put into storage.',
    scanOrderNo:'Scan the VEX tracking number to select the order.',
    norFoundOrder:'No order found',
    scanVEXCode:'Please scan the VEX number for this order',
    scanConfirmVEXCode:'Please enter/scan the VEX number to confirm the order',
    saveNext:'Save,Next',

    consigneeAddress:'Consignee Address',
    consignee:'Consignee',
    mobile:'Mobile',

    numOfInclude:'Number of inclusions',
    unPackCargo:'Sub',
    unPackType:'Sub Type',
    unPackSuccess:'Completed',
    onTheShelf:'On the shelf',

    originCargoNo:'Origin Order.No',
    inputCargoNameOrOther:'Please fill in the item name or alias',
    packageOnShelfRemove:'The package is on the shelf, please remove it first. Shelf location:',
    orderCollection:'Sub collection',
    unPackHistory:'Sub History',
    selectDeliveryTimes:'Please select the delivery time period of the order',
    cargoOnShelf:'Package On/Off Shelf',
    onOffShelf:'On/Off Shelf',
    scanCodeOrRackCode:'Please scan the Code/rack No:',
    warehouseOnShelf:'WH mount of piece',
    myOnShelf:'My mount of piece',
    onShelfScanOne:'input Rack No.',
    onShelfScanTwo:'input Courier No./Order No./Cargo No.',
    onShelfScanThree:'input Rack No./Courier No./Order No./Cargo No.',
    onShelf:'On Shelf',
    offShelf:'Off Shelf',
    newOrder:'New Order',
    originOrder:'Origin Order',
    inWarehouseQuantity:'Origin Inbound Quantity',
    inWarehouseWeight:'Origin Inbound Weight',
    inWarehouseVolume:'Origin Inbound Volume',
    cancelSelectNotSpellBag:'Unchecked orders will not be assembled into the mail bag',
    printScanNotify:'(Temporary code and serial No. can be scanned directly)',
    selectOutTime:'Please select the delivery date',
    deliveryTime:'Delivery time',
    originOrderQrCode:'Original order code',
    collectInputPlaceHolder:'input Cargo No./AWB',
    scanSplitOrder:'Please scan the split order',
    scanOriginOrder:'Please scan the original order',
    currentOriginCollect:'Current origin order collected',
    originalOrder:'Original order',
    current:'Current',
    collected:'Collected',
    collectedAndTotal:'Collected/Total',
    splitOrder:'Split order',
    splitOrderNo:'Split order No.',
    notAggregated:'Not aggregated',
    packageNotInSplit:'The current package is not in the current operation package!',
    scanOriginSplitOrder:'Please scan the original order split package!',
    scanSuccessOriginOrder:'Please scan the correct original order number!',
    collectSuccess:'Operation is successful',
    noOrder:'Pending',
    orderReceived:'Received',
    packScanCargoNotify:'input Cargo No./Courier No./Cargo No.',
    packHistory:'History',
    consigneePhone:'Consignee/Phone',
    unPackInputPlaceHolder:'input Cargo No./Courier No.',
    measureSpellBag:'Measuring',
    capacityOrder:'Capacity order',
    unSpellBag:'To be spell',
    capacityOrderBound:'Whether the capacity order has been bound',
    chooseWaybill:'Choose a wayBill style',
    setBagWeightLimit:'Set bag weight limit',
    packageNotPayPrintTemplate:'The packing slip has not been paid, and the face slip cannot be printed!',
    scanCorrectCargoCode:'Please scan the correct cargo code',
    wrappingWaybill:'Cargo',
    scanSpellBagMeasure:'SpellBag measure',
    scanSuccessShowWeight:'After the scan is successful, the connection is normal and the real-time weight will be displayed',
    waitScanSpellBag:'Waiting',
    measureHistory:'Measurement History',
    measureSuccess:'Success',
    scanSpellBag:'Please scan the spellBag No',
    measureInfo:'Measure Info',
    lookPicture:'Picture',
    bagVolume:'Volume',
    bagVolumeAttr:'L.W.H',
    printCargoNo: 'Print order No.',
    searchSpellHistory: 'View the history of bags (Merge->MergeHistory)',
    details: 'Details',
    notAssignWarehouse: 'You have not currently assigned a warehouse, please contact the manager',
    unPackFail: 'Fail',
    packFail: 'Fail',
    reason: 'Reason',
    currentInWarehouseScanCode: 'Currently in the warehouse operation, please scan the package code or confirmation code',
    outStoreNotifyTitle:'Outbound inspection',
    outStoreNotifyWeightZero:'Check that the package weight is 0. ',
    outStoreNotifyUnPay:'Check whether there are unpaid expenses. ',
    sureOpera:"Confirm?",
    outStoreNotifyScanOut:'You can scan the "Confirmation Code" to confirm',
  returnExpressNo:'Return courier no',

    countQuantity:'Total pieces',
    countWeight:'Total weight',
    countVolume:'Total volume.W',
    volumeWeight:'Volume.W',
    volumeRatioSetting:'V.Ratio',

    defaultWarehouse:'Default Login Warehouse',
    setDefault:'Set Default',

    originalCollectModel:'original collect',
    splitCollectModel:'split collect',

    outWarehouseType:'Out Warehouse Type',
    spellBagAddOrder:'Miss Spell',

    scanPleaseAddOrder:'Scan miss spell code',
    unBind:'Unbind',

    ipAddressAndPortCreated:'IP address & port created!',
    dwsDeviceSetting:'Replace the address and port of the HTTP listening service of the client system with the following generated content in the DWS configuration software. (The red part of the example is what needs to be replaced)',
    dwsRequestDemo:'【 Request Example 】',
    replaceContent:'Content',
    operationCloseDialog:'I\'ve done it. Close the popover',

    languageSetting:'Language',
    seeSetting:'Setting',
    setting:'Setting',
    removeCodeTheFirstStart:'Remove the first',
    removeCodeTheFirstEnd:'digits of code',
    codeOpera:'Code Setting',
    onlyExpressAndTransferNo:'Applicable to Courier/AWB No. only',

    poundWeight:'Pound weight',
    receiptSheet:'Receipt',
    deliverySheet:'Delivery',
    unKnownOrder:'UnKnow',
    orderInWarehoused:'The corresponding order number has been stored',
    orderOutWarehoused:'The corresponding order number has been released from the warehouse',

    export:'Export',
    sequenceNo:'No.',
    orderHasQuantity:'Quantity',
    capacitySubNo:'HAWB',
    capacityNo:'MAWB',
    returnOrder:'Return order',

    capacityOrderType:'Type',
    air:'Air',
    sea:'Sea',

    netWeight:'Net weight',
    adviseShipmentTime:'Advise departure time',
    printShipmentLabel:'Print departure label',
    shipmentInitiator:'Departure initiator',
    exportAndShipment:'Export and departure',
    exportShipmentPlan:'Export plan',
    serviceOrderShipment:'Service order',
    serviceOrderRemark:'Service remark',
    warehouseShipment:'Warehouse departure',
    deliveryDate:'Delivery date',
    shipmentRemark:'Outbound remark',
    shipmentPic:'Outbound Pic',
    returnToStorage:'Again inbound',
    temporarySave:'Save',
    printReceiptLabel:'Print receipt label',
    remove:'Remove',
    submitShipment:'Submit',
    shipmentInfo:'Departure info',
    shipmentOpera:'Departure Opera',
    totalVolume:'Total Volume',
    withPallet:'With pallet',
    noPallet:'No pallet',
    palletType:'Pallet type',
    palletNum:'Num',
    palletWeight:'Pallet weight',
    palletSetting:'Pallet Setting',
    cargoInfo:'Cargo info',
    changeLocation:'Update location',
    cargoInStorageStatus:'Inbound Status',
    weighingData:'Weighing data',
    cargoSize:'Cargo size',
    inboundOpera:'Inbound Opera',
    deliveryCompany:'Delivery Company',
    licencePlateNo:'Licence plate',
    widthDocument:'With document',
    without:'No',
    have:'Yes',
    sealWeight:'Seal weight',
    preVolume:'PreVolume',
    actPieces:'ActPieces',
    actWeight:'ActWeight',
    actVolume:'ActVolume',
    inboundRemark:'Inbound remark',
    preGrossWeight:'Pre gross weight',
    packageType:'Package type',
    cargoIntact:'Intact',
    cargoWeighing:'Weighing',
    cargoBreakage:'Breakage',
    cargoDampness:'Dampness',
    cargoDeformable:'Deformable',
    cargoMissing:'Missing',
    other:'Other',
    receiptLabelEditing:'Receipt label editing',
    inboundNetWeight:'Inbound net weight',
    inboundVolume:'Inbound volume',
    processingComplete:'Complete',
    uploadAnnex:'Upload annex',
    pickUpLicensePlate:'License plate',
    contact:'Contact',
    returnRemark:'Return remark',
    stockedTime:'Stocked time',
    days:'days',
    pleaseRecord:'Please record',
    returnInfo:'return info',
    processingRequirements:'Processing Requirements',
    returnWarehouse:'Return',
    inboundSummary:'Inbound summary',
    returnInitiator:'Return initiator',
    returnInitTime:'Return init time',
    storedTime:'Stored time',
    returnOperaTime:'Opera time',
    estArrivalDate:'Est arrival date',
    selectStatusAndTakePic:'Select the status and take a picture',
    cargoStatus:'Status',
    inboundComplete:'Complete',
    logPieces:'Pieces',
    addNewSize:'Add new',
    cargoMarks:'Marks',
    palletSetDefaultWeight:'Pallet are set by default weight',
    woodPallet:'Wood',
    ironPallet:'Iron',
    paperPallet:'Paper',
    cardBox:'Cardboard Box',
    woodBracket:'Wooden Pallet',
    paperDrum:'Paper Drum',
    canvasRoll:'Canvas Roll',
    wovenBag:'Woven Bag',
    plywoodBox:'Plywood Box',
    pagerSupport:'Paper Pallet',
    plywoodBracket:'Plywood Pallet',
    fba:'FBA',
    commercialExpress:'Commercial Express',
    smallParcel:'Small Parcel',
    eCommercePackage:'E-commerce Package',
    directTransportation:'Direct Transportation',
    generalCargo:'General Cargo',
    sensitiveGoods:'Sensitive Goods',
    dangerousGoods:'Dangerous Goods',
    totalInBoundPieces:'Total pieces inbound',
    totalInBoundNetWeight:'Total net weight inbound',
    locationModification:'Location No. modification',
    currentLocation:'Current',
    selectReplaceLocation:'Select the reservoir location you want to replace',
    pleaseAddPackage:'Enter at least one set of pounded weight!',
    groupWeightNotEmpty:' group weight cannot be empty!',
    groupPiecesNotEmpty:' group pieces cannot be empty or 0!',
    groupPalletPiecesNotEmpty:' group pallet`s pieces cannot be empty or 0!',
    groupPalletWeightNotEmpty:'group pallet`s weight cannot be empty!',
    palletWeightNotExceedPoundWeight:' group pallet`s weight should not exceed the pound weight!',
    sizeGroupPiecesNotEmpty:' size group pieces cannot be empty or 0!',
    sizeGroupLengthNotEmpty:' size group length cannot be empty or 0!',
    sizeGroupWidthNotEmpty:' size group width cannot be empty or 0!',
    sizeGroupHeightNotEmpty:' size group height cannot be empty or 0!',
    poundWeightPiecesNotMatchSize:'The number of pound weight pieces does not match the cargo size!',
    piecesNotZero:'`s pieces cannot be 0!',
    piecesNotEmpty:'`s pieces cannot be null!',
    noOutBoundOrders:'No outbound orders!',
    pleaseSelectDeliveryTime:'Please select the delivery time!',
    service:'Service',
    seeMore:'See more',
    licensePlateNotEmpty:'The license plate cannot be empty!',
    concatNotEmpty:'The concat cannot be empty!',
    pleaseSelectModifyLocation:'Please select the new location!',
    selectNeedOperaOrder:'Manually select the order that requires action',
    preCargoAttr:'Pre pieces/weight/volume',
    poundCargoAttr:'Inbound pieces/pound Weight/volume',
    initReturn:'Initiate return',
    returning:'Returning',
    returned:'Returned',

    includeCargos:'Include cargos',

    previewPrint:'Preview print',
    print:'Print',
    manage:'Manage'
  }
}
// export const en={
//   indexView:{
//     currentLocation:'current location'
//   }
// }



// WEBPACK FOOTER //
// ./src/lang/en.js